import { formatISODateString } from '../../formatter';
export function getGroupingServiceDateRange(grouping) {
    if (grouping.serviceOrders.length === 1) {
        return {
            startDate: new Date(grouping.serviceOrders[0].startDate ?? new Date()),
            endDate: grouping.serviceOrders[0].endDate ? new Date(grouping.serviceOrders[0].endDate) : 'FOREVER',
            string: grouping.serviceOrders[0].startDate === grouping.serviceOrders[0].endDate
                ? formatISODateString(grouping.serviceOrders[0].startDate)
                : `${formatISODateString(grouping.serviceOrders[0].startDate ?? new Date().toString())} - ${grouping.serviceOrders[0].endDate ? formatISODateString(grouping.serviceOrders[0].endDate) : 'On Going'}`,
        };
    }
    const startDate = grouping.serviceOrders.reduce((prev, curr) => {
        if (!curr.startDate)
            return prev;
        const currDate = new Date(curr.startDate);
        return prev < currDate ? prev : currDate;
    }, new Date(grouping.serviceOrders[0].startDate ?? new Date()));
    // for one off services, the start date is the earliest service date
    if (grouping.serviceOrders.every((serviceOrder) => !serviceOrder.subscriptionDetails)) {
        // if the end date is not the same for all service orders, then it is mixed
        const endDate = grouping.serviceOrders.every((serviceOrder) => serviceOrder.endDate === grouping.serviceOrders[0].endDate) &&
            grouping.serviceOrders[0].endDate
            ? new Date(grouping.serviceOrders[0].endDate)
            : 'MIXED';
        return {
            startDate,
            endDate,
            string: `${formatISODateString(startDate.toString())} - ${endDate === 'MIXED' ? 'Mixed' : formatISODateString(endDate.toString())}`,
        };
    }
    // if subscription end date is the same for all service orders, then return the date
    // if subscription end date is the undefined for all service orders, then return forever
    // otherwise return mixed
    let endDate = 'MIXED';
    if (grouping.status !== 'closed') {
        endDate = 'FOREVER';
    }
    else if (grouping.serviceOrders[0].subscriptionDetails?.endDate &&
        grouping.serviceOrders.every((serviceOrder) => serviceOrder.subscriptionDetails?.endDate === grouping.serviceOrders[0].subscriptionDetails?.endDate)) {
        endDate = new Date(grouping.serviceOrders[0].subscriptionDetails?.endDate);
    }
    return {
        startDate,
        endDate,
        string: `${formatISODateString(startDate.toString())} - ${endDate === 'MIXED' ? 'Mixed' : endDate === 'FOREVER' ? 'On Going' : formatISODateString(endDate.toString())}`,
    };
}
//# sourceMappingURL=get-service-grouping-date-range.js.map